// import React, { useEffect, useState } from "react";
// import {
//   Modal,
//   ModalHeader,
//   ModalBody,
//   ModalFooter,
//   Button,
//   FormGroup,
//   Label,
//   Input,
//   FormFeedback, Spinner
// } from "reactstrap";
// import { Formik, Form, Field } from "formik";
// import * as Yup from "yup";
// import toast from "react-hot-toast";
// import useAxios from "../utils/useAxios";
// import { useStore } from "../App";

// const FeedbackSchema = Yup.object({
//   message: Yup.string()
//     .min(10, "Feedback must be at least 10 characters")
//     .required("Feedback is required"),
// });

// const FeedbackComponent = () => {

//   const api = useAxios();

//   const accessToken = useStore((state) => state.accessToken);
//   const userStatus = useStore((state) => state.userStatus);

//   const [alreadySubmitted, setAlreadySubmitted] = useState(null);
//   const [loading, setLoading] = useState(false);

//   const handleSubmit = async (values, { resetForm }) => {
//     try {
//       setLoading(true);
//       await api.post("company/post-feedback", values);
//       toast.success("Feedback submitted successfully");
//       setAlreadySubmitted(true);
//       resetForm();
//     } catch (error) {
//       console.error(error);
//       toast.error("Failed to submit feedback");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     const checkFeedback = async () => {
//       if (!accessToken || !userStatus) {
//         if (alreadySubmitted !== null) setAlreadySubmitted(null);
//         return;
//       }

//       try {
//         const res = await api.get("company/feedback-already-submitted");
//         setAlreadySubmitted(res?.data?.already_submitted ?? false);
//       } catch (error) {
//         console.error("Error checking feedback status", error);
//         setAlreadySubmitted(true);
//       }
//     };

//     checkFeedback();
//   }, [accessToken, userStatus]);

//   return (
//     <div>
//       {
      
//       alreadySubmitted ?
//         <p className="text-center" style={{ height: "100px" }}>You have already submitted feedback.</p>
//         :
//         <Formik
//           initialValues={{ message: "" }}
//           validationSchema={FeedbackSchema}
//           onSubmit={handleSubmit}
//         >
//           {({ errors, touched }) => (
//             <Form>
//               <FormGroup>
//                 <Label for="message">Your Feedback</Label>
//                 <Field
//                   as={Input}
//                   id="message"
//                   name="message"
//                   type="textarea"
//                   rows={4}
//                   invalid={touched.message && !!errors.message}
//                 />
//                 {touched.message && errors.message ? (
//                   <FormFeedback>{errors.message}</FormFeedback>
//                 ) : null}
//               </FormGroup>
//               <Button color="primary" type="submit" disabled={loading}>
//                 {loading ?
//                   <>
//                     <Spinner color="light" size="sm" />
//                     <span style={{ fontSize: "inherit", color: "inherit" }}>{' '}Loading...</span>
//                   </>
//                   : "Submit"}
//               </Button>
//             </Form>
//           )}
//         </Formik>}
//     </div>
//   )
// }

// export default FeedbackComponent


import React, { useEffect, useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Label,
  Input,
  FormFeedback, 
  Spinner
} from "reactstrap";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";
import useAxios from "../utils/useAxios";
import { useStore } from "../App";

const FeedbackSchema = Yup.object({
  message: Yup.string()
    .min(10, "Feedback must be at least 10 characters")
    .required("Feedback is required"),
});

const FeedbackComponent = () => {

  const api = useAxios();

  const accessToken = useStore((state) => state.accessToken);
  const userStatus = useStore((state) => state.userStatus);

  const [alreadySubmitted, setAlreadySubmitted] = useState(null);
  const [loading, setLoading] = useState(false);
  const [checkingStatus, setCheckingStatus] = useState(true); // Add loading state for initial check

  const handleSubmit = async (values, { resetForm }) => {
    try {
      setLoading(true);
      await api.post("company/post-feedback", values);
      toast.success("Feedback submitted successfully");
      setAlreadySubmitted(true);
      resetForm();
    } catch (error) {
      console.error(error);
      toast.error("Failed to submit feedback");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const checkFeedback = async () => {
      if (!accessToken || !userStatus) {
        if (alreadySubmitted !== null) setAlreadySubmitted(null);
        setCheckingStatus(false);
        return;
      }

      try {
        setCheckingStatus(true);
        const res = await api.get("company/feedback-already-submitted");
        setAlreadySubmitted(res?.data?.already_submitted ?? false);
      } catch (error) {
        console.error("Error checking feedback status", error);
        setAlreadySubmitted(true);
      } finally {
        setCheckingStatus(false);
      }
    };

    checkFeedback();
  }, [accessToken, userStatus]);

  // Show spinner while checking status
  if (checkingStatus) {
    return (
       <div className="placeholder-wave">
                        <span className="custom-card placeholder placeholder-lg col-12 mb-2"></span>
                    </div>
    );
  }

  return (
    <div>
      {alreadySubmitted ? (
        <p className="text-center" style={{ height: "100px" }}>
          You have submitted feedback.
        </p>
      ) : (
        <Formik
          initialValues={{ message: "" }}
          validationSchema={FeedbackSchema}
          onSubmit={handleSubmit}
        >
          {({ errors, touched }) => (
            <Form>
              <FormGroup>
                <Label for="message">Your Feedback</Label>
                <Field
                  as={Input}
                  id="message"
                  name="message"
                  type="textarea"
                  rows={4}
                  invalid={touched.message && !!errors.message}
                  style={{'border': '1px solid black'}}
                  placeholder="Please enter your feedback"
                />
                {touched.message && errors.message ? (
                  <FormFeedback>{errors.message}</FormFeedback>
                ) : null}
              </FormGroup>
              <button style={{marginBottom: '20px'}} className="book-btn" type="submit" disabled={loading}>
                {loading ? (
                  <>
                    <Spinner color="light" size="sm" />
                    <span style={{ fontSize: "inherit", color: "inherit" }}>
                      {" "}
                      Loading...
                    </span>
                  </>
                ) : (
                  "Submit"
                )}
              </button>
            </Form>
          )}
        </Formik>
      )}
    </div>
  );
};

export default FeedbackComponent;